import { AlertTriangle } from "lucide-react";
import { STATUS, TONE } from "@/components/sites/bookings/helpers";
import { days, range } from "./dates";

const WD = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
const dnum = (d) => +d.slice(8, 10);

function Chip({ b, conflict, onOpen, compact }) {
  return (
    <button type="button" onClick={() => onOpen(b)} className={`flex w-full min-w-0 items-center gap-1.5 rounded-md border px-1.5 py-1 text-left text-[11px] transition-colors hover:border-sky-400 ${["cancelled", "rejected", "expired"].includes(b.status) ? "border-slate-200 bg-slate-50 text-slate-400 line-through" : "border-slate-200 bg-white text-slate-700"}`}
      aria-label={`${b.local_time} ${b.service_name} ${b.customer?.name || ""} · ${STATUS[b.status]}`} data-testid={`cal-booking-${b.id}`}>
      <span className={`h-2 w-2 shrink-0 rounded-full ${TONE[b.status]?.split(" ")[0] || "bg-slate-200"}`} />
      <b className="shrink-0 tabular-nums">{b.local_time}</b>
      <span className="min-w-0 flex-1"><span className="block truncate font-medium">{b.customer?.name}{b.party > 1 ? ` (${b.party})` : ""}</span>
        {!compact && <span className="block truncate text-[10px] text-slate-500">{b.service_name}</span>}</span>
      {conflict && <AlertTriangle size={11} className="shrink-0 text-amber-600" aria-label="sovrapposizione" />}
    </button>);
}

export function MonthGrid({ anchor, today, byDay, conflicts, onOpen, onDay }) {
  const [a, b] = range("month", anchor);
  return (
    <div className="grid grid-cols-7 overflow-hidden rounded-lg border border-slate-200 bg-slate-200 gap-px" data-testid="cal-month">
      {WD.map((w) => <div key={w} className="bg-slate-50 px-2 py-1 text-[11px] font-medium text-slate-500">{w}</div>)}
      {days(a, b).map((d) => {
        const list = byDay[d] || [];
        const out = d.slice(0, 7) !== anchor.slice(0, 7);
        return (
          <div key={d} className={`min-h-[92px] min-w-0 bg-white p-1 ${out ? "opacity-50" : ""}`} data-testid={`cal-day-${d}`}>
            <button type="button" onClick={() => onDay(d)} className={`mb-1 rounded px-1 text-[11px] ${d === today ? "bg-sky-600 font-semibold text-white" : "text-slate-500 hover:bg-slate-100"}`} aria-label={`Apri il giorno ${d}`}>{dnum(d)}</button>
            <div className="space-y-0.5">{list.slice(0, 3).map((x) => <Chip key={x.id} b={x} compact conflict={conflicts.has(x.id)} onOpen={onOpen} />)}
              {list.length > 3 && <button type="button" onClick={() => onDay(d)} className="text-[10px] text-sky-700 hover:underline" data-testid={`cal-more-${d}`}>+{list.length - 3} altre</button>}</div>
          </div>);
      })}
    </div>);
}

export function DayColumns({ from, to, today, byDay, conflicts, onOpen }) {
  const list = days(from, to);
  return (
    <div className={`grid gap-2 ${list.length > 1 ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-7" : "grid-cols-1"}`} data-testid={list.length > 1 ? "cal-week" : "cal-dayview"}>
      {list.map((d, i) => (
        <section key={d} className="min-w-0 rounded-lg border border-slate-200 bg-white p-2" data-testid={`cal-col-${d}`}>
          <h3 className={`mb-2 text-xs font-semibold ${d === today ? "text-sky-700" : "text-slate-600"}`}>{list.length > 1 ? `${WD[i]} ${dnum(d)}` : "Prenotazioni del giorno"}</h3>
          <div className="space-y-1">{(byDay[d] || []).map((x) => <Chip key={x.id} b={x} conflict={conflicts.has(x.id)} onOpen={onOpen} />)}
            {!(byDay[d] || []).length && <p className="text-[11px] text-slate-400">Nessuna prenotazione</p>}</div>
        </section>))}
    </div>);
}
